enum EncodingType {
  MessageType,
  Int8,
  U8Int,
  Int16LE,
  Int32,
  U16IntLE, // 16 bit number with little endian encoding (first 8 bits are least significant)
  U16IntBE, // 16 bit number with big endian encoding (last 8 bits are least significant)
  Geo,
  StatusBit,
  VariableU8Int,
  RuleNumberCount,
  GPS,
  U32IntLE,
  U32IntBE,
  U64IntLE,
  U64IntBE,
  FP16,
  PulseCountByQuadrant,
}

export type EncodingTypeOf<T> = {
  [k in keyof T]: EncodingType
}

export type GenericEncodingType = {
  [k: string]: EncodingType
}

export type KeysOf<T> = (keyof T)[]

export { EncodingType }
